import React from 'react';
import './ConfirmMaxModal.css';

export const ConfirmMaxModal = ({ isOpen, onClose, onConfirm, tokenName, balance }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">CONFIRM MAXIMUM TRANSFER</h2>
          <button className="modal-close-btn" onClick={onClose} aria-label="Close modal">
            ×
          </button>
        </div>
        <div className="modal-body">
          <p className="modal-warning">
            You are about to transfer <strong>ALL</strong> of your {tokenName} tokens ({balance}{' '}
            {tokenName}) to USDN.
          </p>
          <p className="modal-description">
            This will use your entire {tokenName} balance. Make sure you want to convert all tokens
            before proceeding.
          </p>
        </div>
        <div className="modal-footer">
          <button className="modal-btn modal-btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button className="modal-btn modal-btn-confirm" onClick={onConfirm}>
            Confirm - Transfer All
          </button>
        </div>
      </div>
    </div>
  );
};
